import React, { Component } from "react";
import { Redirect, Route, Switch, withRouter } from "react-router";
import { connect } from "react-redux";
import "bulma/css/bulma.css";

import { SEASON_ID } from "config";
import Matches from "pages/matches";
import Standings from "pages/standings";
import Teams from "pages/teams";
import Players from "pages/players";
import History from "pages/history";
import ExportList from "pages/export/list";
import ExportDetail from "pages/export/detail";
import ScheduleCSV from "pages/schedule-csv";
import NotFound from "pages/not-found";
import LoadingScreen from "components/loading-screen";
import { getTeamsRequest } from "actions/app";

class App extends Component {
  constructor(props) {
    super(props);

    this.state = {
      ready: false,
    };
  }

  componentDidMount() {
    const { dispatch } = this.props;

    switch (SEASON_ID) {
      case "2023-summer":
        require("themes/2023-summer.css");
        break;
      case "2021-winter":
        require("themes/2021-winter.css");
        break;
      case "2022-fall":
        require("themes/2022-fall.css");
        break;
      case "test":
        require("themes/test.css");
        break;
      default:
        break;
    }

    dispatch(getTeamsRequest(SEASON_ID)).then(() => {
      this.setState({
        ready: true,
      });
    });
  }

  render() {
    const { ready } = this.state;

    let classes = ["app", `season-${SEASON_ID}`];
    let content;

    if (ready) {
      content = (
        <Switch>
          <Route
            path="/"
            exact
            render={() => <Redirect from="/" to="/matches" />}
          />
          <Route path="/matches" component={Matches} />
          <Route path="/teams" component={Teams} />
          <Route path="/standings" component={Standings} />
          <Route path="/players" component={Players} />
          <Route path="/history" component={History} />
          <Route path="/export/:seasonId" component={ExportDetail} />
          <Route path="/export" component={ExportList} />
          <Route path="/schedule-csv" component={ScheduleCSV} />
          <Route component={NotFound} status={404} />
        </Switch>
      );
    } else {
      content = <LoadingScreen />;
    }

    return <div className={classes.join(" ")}>{content}</div>;
  }
}

export default withRouter(connect()(App));



// WEBPACK FOOTER //
// ./src/components/app/app.js